import { NavMaterial } from "../../../Hooks/useCategoryNavigation";

export interface NavItem {
  label: string;
  material: NavMaterial;
  /** Whether hovering/expanding reveals the category list. */
  hasMenu: boolean;
}

/**
 * The primary navigation groups. Materials (gold/silver/brilliant) reveal the
 * shared category tree; "Nakit po vašoj želji" links to the About page and
 * "Svi proizvodi" links to the unfiltered listing.
 */
export const NAV_ITEMS: NavItem[] = [
  { label: "Zlato", material: NavMaterial.GOLD, hasMenu: true },
  { label: "Srebro", material: NavMaterial.SILVER, hasMenu: true },
  {
    label: "Brilijanti i drago kamenje",
    material: NavMaterial.BRILIANT,
    hasMenu: true,
  },
  { label: "Nakit po vašoj želji", material: NavMaterial.CUSTOM, hasMenu: false },
  { label: "Svi proizvodi", material: NavMaterial.ALL, hasMenu: false },
];
